import { render, staticRenderFns } from "./NewLandingPlaces.vue?vue&type=template&id=6cfe6bdd&scoped=true"
import script from "./NewLandingPlaces.vue?vue&type=script&lang=js"
export * from "./NewLandingPlaces.vue?vue&type=script&lang=js"
import style0 from "./NewLandingPlaces.vue?vue&type=style&index=0&id=6cfe6bdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfe6bdd",
  null
  
)

export default component.exports